<scf-loader *ngIf="showLoader" [solution]="solution"></scf-loader>
<router-outlet></router-outlet>
